import { useQuery } from '@tanstack/react-query';
import queryKeys from '../keys/queryKeys';
import useMutateHook from '../../useMutateHook';
import { postLogin } from '../service/auth';
import { addPostsComments, deletePost, deletePostsComments, getPosts, getPostsComments, getPostsYearMonth, postPosts } from '../service/posts';

//게시글 조회
export function usePosts({ category, dateFrom, dateTo }) {
  return useQuery({
    queryKey: [...queryKeys.postsKeys.list(category), dateFrom],
    queryFn: () => getPosts({ category, dateFrom, dateTo }),
  });
}

//게시글 등록
export function usePostsSubmit({ category }) {
  return useMutateHook({
    fetchApi: ({ memberId, title, content }) => postPosts({ memberId, title, content, category }),
    invalidQuery: [queryKeys.postsKeys.list(category)],
  });
}

//게시글 삭제
export function usePostDelete({ category }) {
  return useMutateHook({
    fetchApi: async ({ postId }) => {
      console.log('📌 useMutateHook 내부 deletePost 실행됨:', postId);
      const result = await deletePost({ postId });
      console.log('✅ useMutateHook 내부 deletePost 반환값:', result);
      return result;
    },
    invalidQuery: [queryKeys.postsKeys.list(category)],
  });
}

//전체 게시글 생셩 년/월 조회
export function usePostsYearMonth() {
  return useQuery({
    queryKey: queryKeys.postsKeys.yearMonth,
    queryFn: () => getPostsYearMonth(),
  });
}

//게시글 댓글조회
export function usePostsComment({ postId, isView }) {
  return useQuery({
    queryKey: queryKeys.postsKeys.list(postId),
    queryFn: () => getPostsComments({ postId }),
    enabled: !!postId && isView,
  });
}

//게시글 댓글 등록
export function useAddPostComment({ category, memberId, postId }) {
  return useMutateHook({
    fetchApi: ({ comment }) => addPostsComments({ memberId, postId, comment }),
    invalidQuery: [queryKeys.postsKeys.list(category), queryKeys.postsKeys.list(postId)],
  });
}

//게시글 댓글 삭제
export function useDeletePostComment({ category, postId }) {
  return useMutateHook({
    fetchApi: ({ commentId }) => deletePostsComments({ commentId }),
    invalidQuery: [queryKeys.postsKeys.list(category), queryKeys.postsKeys.list(postId), queryKeys.postsKeys.comment],
  });
}
